import { Clipboard } from '@angular/cdk/clipboard';
import {  Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { LoginService } from '../../common/services/Login.service';
import { constObj } from '../../common/Constants/constants';
import { HttpcallService } from '../../common/services/httpcall.service';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-my-bookmark',
  templateUrl: './my-bookmark.component.html',
  styleUrls: ['./my-bookmark.component.css']
})
export class MyBookmarkComponent implements OnInit{
  public displayedColumns = ['Title', 'ParagraphId', 'Dateadded','Action'];
  public dataSource = new MatTableDataSource<myBookmarks>();
  res: myBookmarks[];
  paragraphId: string = "";
  currentRoute: string;

    emailId: string;
  IsBookmark: boolean;
  bookmarkmaintile: any;// ="My Bookmarks";
  titleheadername: any;// ="Title";
  bookmarkheadername: any;// ="Bookmark";
  dateheadername: any;//= "Date added";
  pagesize: any = [10];
  bookmarkLocation: any;
  //actualresult: { ID: string; CreateUserId: string; TopicId: string; ParagraphId: string; BookmarkTitle: string; BookMarkBreadCrumb: string; IsDeleted: boolean; CreatedOn: string; ModifiedOn: string; ApplicationSource: string; BookmarkURL: string;}[];
  actualresult: any;
  pagelistarray: any[] = [];
  noRecords = constObj.Norecords;
  outcome: boolean = false;
  actionheader: any;
  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(private httpCallService: HttpcallService, private session: SessionService, private route: Router,
    public commonDataService: CommonDataService, private loginService: LoginService, private clipboard: Clipboard, private router: Router, private graphQlService: GraphqlService) { }

  ngOnInit() {
    //this.getAllOwners();
   
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.getBookmarkData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.getBookmarkData(this.session.userInfo);
    }
  }

  getBookmarkData(data) {
    this.commonDataService.emailId.next(data.user.email);
    this.emailId = data.user.email;
    this.graphQlService.getGlobalLabels().subscribe(bookkmarkLabel => { this.getmybookmarkLabel(bookkmarkLabel); });
    this.httpCallService.getMyBookmark(this.paragraphId).subscribe((bookmarkData) => { this.mapBookmarkdata(bookmarkData); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.microserviceFailureOnMyBookmark
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });
  }

  public getAllOwners() {
    this.actualresult = [{ "id": "20210920122128327381", "createUserId": "poojas34@deloitte.com", "topicId": "topic1", "paragraphId": "Paragraph 2", "bookmarkTitle": "Sep 20, 2021, 5:51:25 PM", "bookMarkBreadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background", "isDeleted": false, "createdOn": "09/20/2021 12:21:28", "modifiedOn": "09/20/2021 12:21:28", "applicationSource": "FASB", "bookmarkURL": "/17765/17752/codification/general" }, { "id": "20210920122140998380", "createUserId": "poojas34@deloitte.com", "topicId": "topic1", "paragraphId": "Paragraph 3", "bookmarkTitle": "Sep 20, 2021, 5:51:40 PM", "bookMarkBreadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background", "isDeleted": false, "createdOn": "09/20/2021 12:21:40", "modifiedOn": "09/20/2021 12:21:40", "applicationSource": "FASB", "bookmarkURL": "/17765/17752/codification/general" }, { "id": "20210920122146436305", "createUserId": "poojas34@deloitte.com", "topicId": "topic1", "paragraphId": "Paragraph 4", "bookmarkTitle": "Sep 20, 2021, 5:51:46 PM", "bookMarkBreadCrumb": "Presentation,210  Balance Sheet,20  Offsetting,05  Overview and Background", "isDeleted": false, "createdOn": "09/20/2021 12:21:46", "modifiedOn": "09/20/2021 12:21:46", "applicationSource": "FASB", "bookmarkURL": "/17765/17752/codification/general" }]    
    var ress = this.actualresult.map(x => ({ id: x.id, Title: x.bookmarkTitle, Bookmark: x.bookMarkBreadCrumb.split("~"), Dateadded: new Date(x.createdOn), ParagraphId: x.paragraphId, BookmarkURL: location.origin + x.bookmarkURL }))
    for (let i = 5; i <= 20; i= i+5 ) {
     this.pagelistarray.push(i);
    }
    this.dataSource.data = ress as unknown as myBookmarks[];
      //})
  }
 
  public redirectToDetails = (id: string) => {

  }
  getmybookmarkLabel(data) {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.bookmarkmaintile = labels.filter(x => x.key == "myBookmarks_header").map(y => y.value);
        this.titleheadername = labels.filter(x => x.key == "myBookmarks_columnOne").map(y => y.value);
        this.bookmarkheadername = labels.filter(x => x.key == "myBookmarks_columnTwo").map(y => y.value);
        this.dateheadername = labels.filter(x => x.key == "myBookmarks_columnThree").map(y => y.value);
        this.actionheader = labels.filter(x => x.key == "global_action").map(y => y.value);

        //this.commonDataService.showLoader.next(false);
      }
  }
  public copyToClipboard = (id: string, URL: string, Title: string, location1: string[]) => {
    let BreadcrumbLocation = location1.join(' -> ')
    if ((!URL?.startsWith("/") && URL?.split("/").length < 3) || (URL?.startsWith("/") && URL?.split("/").length <= 3)){
      URL = "/" + URL?.split("/")[1] + "/" + URL?.split("/")[2]+"/"+location1[location1.length-1];
    }
    this.clipboard.copy("Bookmark: " + Title + "\nLink: " + location.origin + URL + "\nLocation: " + BreadcrumbLocation);
    let obj = {
      type: 'success',
      displayTime: 5000,
      position: 'bottom',
      message: constObj.linkSharedMessage
    }
    this.commonDataService.notificationObject.next(obj);
  }

  public redirectToDelete = (id: string) => {
    this.commonDataService.showLoader.next(true);
    var bookmarkarray = this.actualresult.filter(x => x.id == id)[0];
    var bookmark = {
      ID: bookmarkarray.id, TopicId: bookmarkarray.topicId, ParagraphId: bookmarkarray.paragraphId, BookmarkTitle: bookmarkarray.bookmarkTitle, BookMarkBreadCrumb: bookmarkarray.bookMarkBreadCrumb, IsDeleted: true, CreatedOn: bookmarkarray.createdOn, ModifiedOn: bookmarkarray.modifiedOn, ApplicationSource: bookmarkarray.applicationSource,
      BookmarkURL: bookmarkarray.bookmarkURL, NavigationPath: bookmarkarray.navigationPath
    }
    this.httpCallService.addUpdateBookmark(bookmark).toPromise()
      .then(response => {
        //this.closeOverlay();
        this.commonDataService.showLoader.next(false);
        let obj = {
          type: 'success',
          displayTime: 5000,
          position: 'bottom',
          message: constObj.bookmarkRemovedMessage
        }
        this.commonDataService.notificationObject.next(obj);
        this.getBookmarkdata();
      })
      .catch(res => {
        console.log(res);
        this.commonDataService.showLoader.next(false);
      });
  }

  getBookmarkdata() {
    this.httpCallService.getMyBookmark(this.paragraphId)
      .subscribe(resp => { this.mapBookmarkdata(resp); }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
  }


  mapBookmarkdata(resp) {
      this.actualresult = resp;
      if (this.actualresult[0]) {
        this.bookmarkLocation = this.actualresult[0].bookMarkBreadCrumb;
      }
      this.IsBookmark = resp.length > 0 ? true : false;
      let ress = this.actualresult.map(x => ({ id: x.id, Title: x.bookmarkTitle, Bookmark: x.bookMarkBreadCrumb.split("~"), Dateadded: new Date(x.createdOn), ParagraphId: x.paragraphId, BookmarkURL: x.bookmarkURL }))
      for (let i = 5; i <= 20; i = i + 5) {
        this.pagelistarray.push(i);
      }
      this.dataSource.data = ress as unknown as myBookmarks[];
  }

  NavigateTo(url, id, topic, paraId) {
    if (topic != "20 Glossary") {
      if ((!url?.startsWith("/") && url?.split("/").length < 3) || (url?.startsWith("/") && url?.split("/").length <= 3)) {
        url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + id;
      }
    }
    else {
      url = "/" + url?.split("/")[1] + "/" + url?.split("/")[2] + "/" + paraId;
    }
    this.route.navigateByUrl(url);
  }
  
}

export interface myBookmarks {
  id:string
  Title: string;
  Bookmark: string;
  Dateadded: Date;
  ParagraphId: string;
  BookmarkURL: string;
}
